import type { Mission } from '../missions.ts'

export const doe: Mission = {
  id: "doe",
  name: "U.S. Department of Energy",
  short: "DOE",
  call: "Energy",
  kind: "department",
  url: "https://www.energy.gov/",
  established: 1977,
  palette: {
    primary: "#1a204c",
    secondary: "#01804e",
    accent: "#ffb000",
  },
  colorSource: {
    kind: "site",
    url: "https://www.energy.gov/",
  },
  motif: "bolt",
  mission: {
    text: "The mission of the Energy Department is to ensure America’s security and prosperity by addressing its energy, environmental and nuclear challenges through transformative science and technology solutions.",
    url: "https://www.energy.gov/mission",
  },
  fact: {
    text: "President Carter signed the Department of Energy Organization Act on August 4, 1977.",
    url: "https://www.energy.gov/management/august-4-1977-president-carter-signs-department-energy-organization-act",
  },
  seal: {
    file: "public/seals/doe.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_Energy.svg",
  },
  logo: {
    file: "public/logos/doe.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-department-of-energy-logo.svg",
  },
  identifier: {
    about: "https://www.energy.gov/mission",
    accessibility: "https://www.energy.gov/cio/accessibility-standard-statement",
    foia: "https://www.energy.gov/gc/freedom-information-act",
    noFear: "https://www.energy.gov/eeocr/no-fear-act-data",
    oig: "https://www.energy.gov/ig/office-inspector-general",
    performance: "https://www.energy.gov/budget-performance",
    privacy: "https://www.energy.gov/about-us/web-policies/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/doe-wind-farm.jpg",
        small: "/media/doe-wind-farm-sm.jpg",
        alt: "Aerial view of white wind turbines standing across rolling golden farmland under a blue sky, with snowy mountains on the horizon.",
        title: "Power County Wind Farm, Power County, Idaho",
        creator: "U.S. Department of Energy",
        source: "https://commons.wikimedia.org/wiki/File:Power_County_Wind_Farm_002.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/doe-solar-array.jpg",
        small: "/media/doe-solar-array-sm.jpg",
        alt: "Long rows of blue photovoltaic panels stretching toward desert mountains under a cloudy sky.",
        title: "Photovoltaic power station, Utah",
        creator: "Reegan Moen, U.S. Department of Energy",
        source: "https://commons.wikimedia.org/wiki/File:Utah_solar;_a_photovoltaic_power_station_(36293687776).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
